// src/index.tsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrandProvider } from './providers/BrandProvider';
import { NewChatApp } from './NewChatApp';
import { LanguageProvider } from './i18n/LanguageProvider';
import { getCurrentLanguage, setCurrentLanguage } from './i18n/language';
import { getBrandConfig, getDefaultBrandLanguage } from './brands/brand-registry';

const defaultLanguage = getDefaultBrandLanguage();
const allowLanguageSelection = getBrandConfig().features.showLanguageSwitcher;
const initialLanguage = allowLanguageSelection
  ? getCurrentLanguage(defaultLanguage)
  : defaultLanguage;
setCurrentLanguage(initialLanguage);

function Root() {
  const [theme, setTheme] = useState<'light'|'dark'>('light');

  useEffect(() => {
    const stored = localStorage.getItem('themeMode') as 'light'|'dark' | null;
    if (stored) setTheme(stored);
  }, []);
  useEffect(() => {
    localStorage.setItem('themeMode', theme);
  }, [theme]);

  return (
    <LanguageProvider
      defaultLanguage={defaultLanguage}
      allowLanguageSelection={allowLanguageSelection}
    >
      <BrandProvider mode={theme}>
        <div className="App">
          <NewChatApp />
        </div>
      </BrandProvider>
    </LanguageProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
